import { proxy } from 'valtio';
import { AlertMessage } from '../shared/models/error.model';
export const genericStore = proxy({
	alerts:[] as AlertMessage[],
	setAlert: (value: AlertMessage)  => {   
		genericStore.alerts = [...genericStore.alerts, value]
	},
	deleteAlert : (id: String) => {
		const alerts = genericStore.alerts.filter((item: AlertMessage) => item.id !== id);
		genericStore.alerts = alerts;
	}
      
  });
